'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

var _reactTransitionGroup = require('react-transition-group');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var _this = this;

    var label = null,
        classList = this.compileStyle(_index2.default),
        digits = [],
        lastDigit = void 0,
        bullets = [],
        i = 0,
        filledCount = this.props.value ? this.props.value.length : 0;

    if (this.props.label) {
        label = _react2.default.createElement(
            'label',
            { className: classList.label },
            this.props.label
        );
    }

    var animation = this.state.animation.map(function (item) {
        return _react2.default.createElement(
            _reactTransitionGroup.CSSTransition,
            {
                classNames: classList.animation,
                timeout: { enter: 2000 },
                exit: false,
                key: item.id
            },
            _react2.default.createElement('div', { className: classList.animation, style: item })
        );
    });

    this.props.collection.forEach(function (value, i) {
        if (i === 9) return;

        digits.push(_react2.default.createElement(
            'button',
            {
                key: 'digit-' + value,
                className: classList.digit,
                type: 'button',
                onClick: function onClick(e) {
                    return _this.select(value, e);
                }
            },
            _react2.default.createElement(
                'span',
                null,
                String(value)
            )
        ));
    });

    lastDigit = this.props.collection[this.props.collection.length - 1];

    digits.push(_react2.default.createElement(
        'button',
        { className: classList.digit, type: 'button', key: 'digit-clear', onClick: this.clear.bind(this) },
        _react2.default.createElement('span', { className: classList.clear })
    ), _react2.default.createElement(
        'button',
        {
            className: classList.digit,
            type: 'button',
            key: 'digit-' + lastDigit,
            onClick: function onClick(e) {
                return _this.select(lastDigit, e);
            }
        },
        _react2.default.createElement(
            'span',
            null,
            lastDigit
        )
    ), _react2.default.createElement(
        'button',
        { className: classList.digit, type: 'button', key: 'digit-c', onClick: this.clearDigit.bind(this) },
        _react2.default.createElement('span', { className: classList.deleteDigit })
    ));

    for (i; i < this.props.maxLength; i++) {
        bullets.push(_react2.default.createElement('div', {
            key: 'bullet-' + i,
            className: i < filledCount ? classList.bulletFilled : classList.bullet
        }));
    }

    return _react2.default.createElement(
        'div',
        { className: classList.root + ' ' + (this.props.className || '') },
        label,
        _react2.default.createElement(
            'div',
            { className: classList.bulletWrapper },
            bullets
        ),
        _react2.default.createElement(
            'div',
            { className: classList.dial },
            _react2.default.createElement(
                _reactTransitionGroup.TransitionGroup,
                null,
                animation
            ),
            digits,
            _react2.default.createElement('input', {
                type: 'text',
                value: this._stringify(),
                onChange: this._handleChange.bind(this),
                ref: this._inputRef.bind(this),
                className: classList.input
            })
        )
    );
}